import React from 'react'
import { CreditDocument } from '_gql'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

export const documentTypeValidationSchema = yup.object().shape({
  documentType: yup
    .string()
    .oneOf(Object.values(CreditDocument))
    .required(() => (
      <FormattedMessage
        defaultMessage='Document type selection is required'
        id='sputnik.DocumentUploadTypeModal__59iqQS'
      />
    )),
})

export type DocumentTypeValidationSchema = yup.InferType<typeof documentTypeValidationSchema>
